export enum AmpEventSourceTypeDataPlatform {
    DATA_PLATFORM = 'data platform'
}